import React from "react";
import FilterContainer, { CoreFiltersBaseProps } from "../../../../../components/FilterContainer";
import { Collapse, Form, Input, Select } from "antd";
import DateRangePicker from "../../../../../../../components/forms/controls/DateRangePicker";
import { useGetAllUsersQuery } from "../../../../../../../store/services/api/user-api";
import { DateTime } from "luxon";
import { ApprovalStatus } from "../../../../../../../store/data/models/approval-status-form";

const { Panel } = Collapse;

export default function PreventativeMaintenancesListScreenFilters({ filter, onSubmit }: CoreFiltersBaseProps) {
  const { data: allUsers } = useGetAllUsersQuery();

  return (
    <FilterContainer onResetFilters={filter.resetFilters} onSubmit={onSubmit} isSubmitting={undefined}>
      <Collapse defaultActiveKey={['general', 'createdInfo', 'status']} ghost>
        {/* General Info Section */}
        <Panel header="General Info" key="general">
          <Form layout="vertical">
            <Form.Item label="Reference">
              <Input
                allowClear
                value={filter.getFilter('reference')}
                onChange={e => filter.setFilter('reference', e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Description">
              <Input
                allowClear
                value={filter.getFilter('description')}
                onChange={e => filter.setFilter('description', e.target.value)}
              />
            </Form.Item>
          </Form>
        </Panel>

        {/* Created Info Section */}
        <Panel header="Created/Approved Info" key="createdInfo">
          <Form layout="vertical">
            <Form.Item label="Created By">
              <Select
                mode="multiple"
                allowClear
                showSearch
                filterOption={(input, option) => {
                  const text = String((option as any).label  || '');
                  return text.toLowerCase().includes(input.toLowerCase());
                }}
                value={filter.getFilter('createdByUserId')}
                onChange={val => filter.setFilter('createdByUserId', val)}
                options={allUsers?.map(u => ({ label: u.name, value: u.id }))}
              />
            </Form.Item>
            <Form.Item label="Created On">
              <DateRangePicker
                onStartDateChange={val => filter.setFilter('createdOnStartDate', val?.toISO())}
                onEndDateChange={val => filter.setFilter('createdOnEndDate', val?.toISO())}
                startDateValue={filter.getFilter('createdOnStartDate') ? DateTime.fromISO(filter.getFilter('createdOnStartDate')) : undefined}
                endDateValue={filter.getFilter('createdOnEndDate') ? DateTime.fromISO(filter.getFilter('createdOnEndDate')) : undefined}
              />
            </Form.Item>
            <Form.Item label="Approved By">
              <Select
                mode="multiple"
                allowClear
                showSearch
                filterOption={(input, option) => {
                  const text = String((option as any).label  || '');
                  return text.toLowerCase().includes(input.toLowerCase());
                }}
                value={filter.getFilter('approvedByUserId')}
                onChange={val => filter.setFilter('approvedByUserId', val)}
                options={allUsers?.map(u => ({ label: u.name, value: u.id }))}
              />
            </Form.Item>
          </Form>
        </Panel>

        {/* Status Section */}
        <Panel header="Status" key="status">
          <Form layout="vertical">
            <Form.Item label="Status">
              <Select
                mode="multiple"
                allowClear
                showSearch
                filterOption={(input, option) => {
                  const text = String((option as any).children  || '');
                  return text.toLowerCase().includes(input.toLowerCase());
                }}
                value={filter.getFilter('status')}
                onChange={val => filter.setFilter('status', val)}
              >
                <Select.Option value={ApprovalStatus.AwaitingApproval}>Awaiting Approval</Select.Option>
                <Select.Option value={ApprovalStatus.Approved}>Approved</Select.Option>
                <Select.Option value={ApprovalStatus.Rejected}>Rejected</Select.Option>
              </Select>
            </Form.Item>
          </Form>
        </Panel>
      </Collapse>
    </FilterContainer>
  );
}
